import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber, Switch,DatePicker,Input,Radio } from 'antd';
import { createTwoDcollection } from '../../redux/actions/twoDcollection/createTwoDcollection';
import * as actionTypes from '../../redux/actions/twoDcollection/actionTypes';
import moment from 'moment';
import {
    CheckOutlined,
    CloseOutlined
} from '@ant-design/icons';

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 24 },
};

class AddTwoDCollectionModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onCreate({
            ...values,
            date: values.date.utc()
        },
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        const dateFormat = "DD/MM/YYYY";
        return (
            <Modal
                width={800}
                title="Create 2D Collection"
                key="c3dc"
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'create-2dc-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                 <Form
                            id="create-2dc-form"
                            ref={this.form}
                            {...layout}
                            loading={this.props.loading}
                            name="basic"
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                            initialValues={{
                                period:'AM',
                                copyFromPreviousCollection:false,
                                date:moment().utc()
                            }}
                        >
                            <Form.Item
                                name="collectionId"
                                label="CollectionID"
                                rules={[
                                    {
                                        required: true,
                                        message: 'require',
                                    },
                                ]}
                            >
                                <Input style={{ width: 200 }} />
                            </Form.Item>
                            <Form.Item
                                label="Period"
                                name="period"
                                rules={[
                                    {
                                        required: true,
                                        message: 'require',
                                    },
                                ]}
                            >
                                <Radio.Group>
                                    <Radio.Button value='AM'>AM</Radio.Button>
                                    <Radio.Button value='PM'>PM</Radio.Button>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item
                                name="copyFromPreviousCollection"
                                label="Copy From Previous Collection"
                                rules={[
                                    {
                                        required: true,
                                        message: 'require',
                                    },
                                ]}
                            >
                                <Switch
                                    checkedChildren={<CheckOutlined />}
                                    unCheckedChildren={<CloseOutlined />}
                                />
                            </Form.Item>
                            <Form.Item
                                name="date"
                                label="Date"
                                rules={[
                                    {
                                        required: true,
                                        message: 'require',
                                    },
                                ]}
                            >
                                <DatePicker format={dateFormat} />
                            </Form.Item>
                        </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.twoDCollection.addVisible,
    loading: state.twoDCollection.loading,
    token: state.auth.token,
    error: state.twoDCollection.error,
    message: state.twoDCollection.message,
})

const mapDispatchToProps = dispatch => ({
    onCreate: (obj, token) => dispatch(createTwoDcollection(obj, token)),
    onClose: () => dispatch({
        type: actionTypes.TOGGLE_2D_COLLECTION_ADD
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddTwoDCollectionModal);